<template>
  <div class="tab-bar">
    <van-tabbar v-model="ac">
      <van-tabbar-item icon="home-o" to="/home">首页</van-tabbar-item>
      <van-tabbar-item icon="contact" to="/user">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
    export default {
        name: 'Tabbar',
        props: {
            active: Number
        },
        data() {
            return {
                ac: this.active
            }
        },
        computed: {

        },
        methods:{

        }
    }
</script>

<style scoped>

</style>
